import React from 'react';
import { Field, withFormik } from 'formik';
import { get, trim } from 'lodash';
import { em } from 'polished';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Yup from 'yup';

import {
  Button,
  ErrorMessage,
  Form,
  GridContainer,
  GridItem,
  TextFieldWrapper,
} from '../../common';
import { appTheme } from '../../../theme';

const LoginButton = styled(Button)`
  align-self: center;
  margin-top: calc(${appTheme.spacing.default} * 2);
  width: ${em('150px')};
`;
class EmailLoginForm extends React.Component {
  handleChange = event => {
    this.props.setStatus({ loginError: null });
    return this.props.handleChange(event);
  };

  render() {
    const { handleSubmit, status } = this.props;
    const loginError = get(status, 'loginError');
    return (
      <Form onSubmit={handleSubmit}>
        <GridContainer>
          <GridItem xs={12}>
            <Field
              autoComplete="username"
              className="text-field"
              component={TextFieldWrapper}
              id="email"
              label="Email"
              margin="normal"
              name="email"
              onChange={this.handleChange}
            />
          </GridItem>
          <GridItem xs={12}>
            <Field
              autoComplete="current-password"
              className="text-field"
              component={TextFieldWrapper}
              id="password"
              label="Password"
              margin="normal"
              name="password"
              onChange={this.handleChange}
              type="password"
            />
          </GridItem>
        </GridContainer>
        {loginError && <ErrorMessage>{loginError}</ErrorMessage>}
        <LoginButton type="submit">Login</LoginButton>
      </Form>
    );
  }
}

EmailLoginForm.propTypes = {
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  status: PropTypes.object,
};

EmailLoginForm.defaultProps = {
  status: {},
};

export default withFormik({
  displayName: 'LoginForm',
  handleSubmit: (values, { props, setStatus }) => {
    return props
      .onLogin(trim(values.email), values.password)
      .catch(error => setStatus({ loginError: error }));
  },
  mapPropsToValues: () => ({
    email: '',
    password: '',
  }),
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .trim()
      .email('Please enter a valid email address.')
      .required('Email address is required.'),
    password: Yup.string().required('Password is required.'),
  }),
})(EmailLoginForm);



// WEBPACK FOOTER //
// ./src/modules/LoginFormPage/components/EmailLoginForm.js